import { UserGroupIcon, ClipboardDocumentListIcon, BanknotesIcon, FlagIcon } from '@heroicons/react/24/outline';

const HR_WORKFLOWS = ['manage_hr_reviews', 'manage_hr_compensation', 'manage_hr_lifecycle'];

/**
 * The sidebar's People & HR links (WeCare only), or null when the person has none. Each link follows its
 * own permission. An employee with only My Goals gets one link, Reviews & Goals, to their own goals page;
 * an HR reviewer with My Goals gets it as a separate My Goals link.
 */
export function peopleHrNav({ organizationSlug, user, hasPermission, pathname, search }) {
  const all = user?.role === 'super_admin';
  if (organizationSlug !== 'wecare-health' || !(all || [...HR_WORKFLOWS, 'manage_exclusion_checks', 'view_my_goals'].some(hasPermission))) return null;
  const hrArea = new URLSearchParams(search).get('area') || 'ALL';
  const onHrPage = pathname === '/admin/people-hr';
  const children = all || HR_WORKFLOWS.some(hasPermission)
    ? [{ name: 'HR Overview', href: '/admin/people-hr', icon: UserGroupIcon, current: onHrPage && hrArea === 'ALL' }]
    : [];
  if (user?.email?.trim().toLowerCase() === 'ola@wecaremn.org' || ['manage_hr_lifecycle', 'view_provider_employment_tab', 'view_all_hr_staff'].every(hasPermission)) {
    children.push({ name: 'Applicants', href: '/admin/people-hr/applicants', icon: UserGroupIcon, current: pathname === '/admin/people-hr/applicants' });
  }
  if (hasPermission('manage_exclusion_checks')) {
    children.push({ name: 'Exclusion checks', href: '/admin/exclusion-checks', icon: ClipboardDocumentListIcon, current: pathname === '/admin/exclusion-checks' });
  }
  if (all || hasPermission('manage_hr_reviews')) {
    children.push({ name: 'Reviews & Goals', href: '/admin/people-hr?area=REVIEW', icon: ClipboardDocumentListIcon, current: onHrPage && ['REVIEW', 'GOAL', 'SUPERVISION'].includes(hrArea) });
    // A reviewer is also an employee: their own goals and their department's company goals.
    if (hasPermission('view_my_goals')) children.push({ name: 'My Goals', href: '/admin/people-hr/my-goals', icon: FlagIcon, current: pathname === '/admin/people-hr/my-goals' });
  } else if (hasPermission('view_my_goals')) {
    // Staff without HR access: their own goals and their department's company goals.
    children.push({ name: 'Reviews & Goals', href: '/admin/people-hr/my-goals', icon: ClipboardDocumentListIcon, current: pathname === '/admin/people-hr/my-goals' });
  }
  if (all || hasPermission('manage_hr_compensation')) {
    children.push({ name: 'Compensation', href: '/admin/people-hr?area=COMPENSATION', icon: BanknotesIcon, current: onHrPage && hrArea === 'COMPENSATION' });
  }
  if (all || hasPermission('manage_hr_lifecycle')) {
    children.push({ name: 'Employee Workflows', href: '/admin/people-hr?area=ONBOARDING', icon: UserGroupIcon, current: onHrPage && ['ONBOARDING', 'OFFBOARDING', 'REQUEST'].includes(hrArea) });
  }
  return children;
}
